export function Logo() {
  return <a href="/" className="logo" aria-label="Touchline TCG home"><span className="logo-mark">T</span><span>TOUCHLINE<small>TACTICAL CARD FOOTBALL</small></span></a>;
}
